import { useState, useEffect } from 'react';

export const useFieldSelection = () => {
  const alwaysSelected = ['origin', 'destination', 'mktcarrier', 'opcarrier', 'effdt'];
  const expandedFields = [
    'origin_name', 'destination_name', 'destination_country', 'destination_region',
    'mktcarrier_name', 'opcarrier_name'
  ];
  const expandedDupLegFields = [
    'dupleg', 'cs_flights'
  ];
  const toggleField = 'o_d_c_name';
  const toggleDupLegField = 'dupleg_flight';

  const [selectedFields, setSelectedFields] = useState([...alwaysSelected]);
  const [draftFields, setDraftFields] = useState([...alwaysSelected]);

  const handleFieldChange = (fieldKey, isChecked) => {
    setDraftFields(prev => {
      const newSet = new Set(prev);

      if (isChecked) {
        newSet.add(fieldKey);
        //if (fieldKey === toggleField ) {
        //  expandedFields.forEach(f => newSet.add(f));
        // }
        if (fieldKey === toggleDupLegField) {
          expandedDupLegFields.forEach(f => newSet.add(f));
        }  
      } else {
        if (alwaysSelected.includes(fieldKey)) return prev;
        newSet.delete(fieldKey);
        //if (fieldKey === toggleField ) {
        //  expandedFields.forEach(f => newSet.delete(f));
        //}
        if (fieldKey === toggleDupLegField) {
          expandedDupLegFields.forEach(f => newSet.delete(f));
        } 
      }

      return Array.from(newSet);
    });
  };

  const commitSelection = () => {
    setSelectedFields([...draftFields]);
  };

  // Derived field: used only for table display (excludes toggleField)
  const filteredFieldsForDisplay = selectedFields.filter(f => f !== toggleField && f !== toggleDupLegField);

  useEffect(() => {
    setDraftFields(prev => {
      const newSet = new Set([...prev, ...alwaysSelected]);
      return Array.from(newSet);
    });
  }, []);

  return {
    selectedFields,
    draftFields,
    filteredFieldsForDisplay,
    handleFieldChange,
    commitSelection
  };
};
